<template>
  <!-- viewer product list  --->
  <div class="itemCard_Panel">
    <div class="itemCards" v-if="viewerProductList">
      <img
        v-if="viewerProductList"
        :src="viewerProductList.itemImage || viewerProductList.displayImage"
      />
      <span class="buyers_count"
        >{{ viewerProductList.view || viewerProductList.viewersCount }}
        {{ $t('boughtthisdeal') }}</span
      >
      <span class="your_amount">{{
        viewerProductList.itemName || viewerProductList.productName
      }}</span>
      <span class="item_amount">
        ₹
        {{
          viewerProductList.totalPaidAmount || viewerProductList.sellingPrice
        }}
        <span class="actual_amount">
          ₹
          {{
            viewerProductList.sellingPrice || viewerProductList.markedPrice
          }}</span
        >
      </span>
      <div class="golive_btn">
        <button
          @click="
            handleProductPurchase(
              viewerProductList.ordered_id || viewerProductList.saleReferenceID,
              viewerProductList.uniqueLink || viewerProductList.clickUrl
            )
          "
          type="button"
          class="btn_red"
        >
          {{ $t('buyNow') }}
        </button>
      </div>
    </div>

    <div class="itemCards" v-else>
      <img
        src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTQazJBcUCwI50Edc-BD7s-nEYCxTEb5gJ9pwlyx98daW1tqVSV"
      />
      <span class="buyers_count">{{ $t('noProduct') }}</span>
      <!-- <span class="your_amount"></span> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewerProductList',
  props: ['room_id', 'roomOwnerXAuthID', 'channel', 'viewerProductList'],
  watch: {
    viewerProductList: function(newVal, oldVal) {
      console.log('--===-=newVal==', newVal)
      console.log('--===-==oldVal=', oldVal)
    }
  },
  methods: {
    handleProductPurchase(ordered_id, uniqueLink) {
      console.log('link>>>>>>> ', ordered_id, uniqueLink)
      this.$cookie.set('isRedirecting', 'true')

      this.$socket.emit('viewed_by_viewer', {
        ordered_id: ordered_id,
        x_auth_id: this.roomOwnerXAuthID,
        room_id: this.channel
      })
      window.location.href = uniqueLink
    }
  }
}
</script>
